<template>
  <section class="pv-32">
    <div class="ph-16">
      <bl-text-av class="u-txt--center" tag="h2" variation="heading-24" weight="bold">
        {{ $options.benefits.title }}
      </bl-text-av>
    </div>

    <div class="pv-16">
      <bl-slider-mv
        class="mb-16"
        :items="benefitItems.length"
        :slider-item-height="276"
        :slider-item-width="300"
        :is-show-indicator="false"
        :is-looping="false"
        background-slider="transparent"
        @itemChange="onItemChange"
      >
        <article v-for="(item, index) in benefitItems" :key="index" :slot="`item${index + 1}`">
          <bl-card-mv class="p-20" style="height: 276px;" is-outlined>
            <div class="mb-20">
              <new-webp-image-container
                :src="item.image"
                :alt="item.title"
                :is-ssr="isSSR"
                styles="width: 64px; height: 64px"
              />
            </div>

            <bl-text-av tag="h3" class="mb-12" variation="subheading-20" weight="semi-bold">
              {{ item.title }}
            </bl-text-av>

            <bl-text-av variation="body-long-14">
              {{ item.subtitle }}
            </bl-text-av>
          </bl-card-mv>
        </article>
      </bl-slider-mv>

      <bl-flex-container-mv class="ph-16" justify-content="center">
        <bl-flex-item-av>
          <bl-slider-indicator-av :count="benefitItems.length" :active="activeIndicator" />
        </bl-flex-item-av>
      </bl-flex-container-mv>
    </div>
  </section>
</template>

<script>
/* istanbul ignore file */
import BlTextAv from '@bukalapak/bazaar-mweb-2/dist/components/BlTextAv';
import { Benefits as benefits } from 'shared/modules/seo/Homepage';
import BlSliderMv from '@bukalapak/bazaar-mweb-2/dist/components/BlSliderMv';
import BlCardMv from '@bukalapak/bazaar-mweb-2/dist/components/BlCardMv';
import BlSliderIndicatorAv from '@bukalapak/bazaar-mweb-2/dist/components/BlSliderIndicatorAv';
import NewWebpImageContainer from 'shared/components/NewWebpImageContainer';
import BlFlexContainerMv from '@bukalapak/bazaar-mweb-2/dist/components/BlFlexContainerMv';
import BlFlexItemAv from '@bukalapak/bazaar-mweb-2/dist/components/BlFlexItemAv';

export default {
  name: 'Benefits',

  benefits,

  components: {
    BlTextAv,
    BlSliderMv,
    BlCardMv,
    BlSliderIndicatorAv,
    NewWebpImageContainer,
    BlFlexContainerMv,
    BlFlexItemAv,
  },

  data() {
    return {
      activeIndicator: 1,
    };
  },

  computed: {
    benefitItems() {
      return this.$options.benefits.items;
    },
    isSSR() {
      return this.$root.isSSR;
    },
  },

  methods: {
    onItemChange(index) {
      this.activeIndicator = index;
    },
  },
};
</script>
